import React from "react";

const items = [
  "CALLING ALL BANDITS 🎄",
  "FALL & CHRISTMAS CANDY BOUQUETS",
  "STOCKING STUFFERS INCLUDED 🎁",
  "WE SHIP EVERY FRIDAY BEFORE 12 PM CST 🚚",
];

export const Marquee = ({ bg = "bg-candy-gold", text = "text-black" }) => {
  const loop = [...items, ...items];
  return (
    <div className={`${bg} ${text} border-y-4 border-black overflow-hidden py-2`} data-testid="marquee-banner">
      <div className="marquee-track">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-mono font-bold text-sm sm:text-base uppercase tracking-widest px-6 whitespace-nowrap flex items-center"
          >
            {t} <span className="mx-3 text-candy-pink">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
